export const dialogProps = (rootState) => rootState.dialogs.activeDialog.dialogProps;
